import axios from "axios";
import { Dispatch } from "redux";
// import { useNavigate } from "react-router-dom";
// import { all_routes } from "../../../../feature-module/router/all_routes";

import {
  USER_PROFILE,
  USER_PROFILE_SUCCESS,
  USER_PROFILE_FAILURE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  SETTINGS,
  SETTINGS_SUCCESS,
  SETTINGS_FAILURE,
  GET_CURRENT_LOCATION,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  RESET_AUTH_STATE,
  PASSWORD_AUTHENTICATE,
  PASSWORD_AUTHENTICATE_SUCCESS,
  PASSWORD_AUTHENTICATE_FAILURE,
  REGISTER,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  RESET_PASSWORD_AUTHENTICATE,
  AuthActionTypes,

  VERIFY_OTP,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
} from "../types/authTypes";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });
// const routes = all_routes;

API.defaults.withCredentials = true;
// const navigate = useNavigate();

export const googleLogin = () => {
  window.location.href = `${process.env.REACT_APP_API_URL}/auth/google`;
};

export const registerUser =
  (data: any) => async (dispatch: Dispatch<AuthActionTypes>) => {
    try {
      dispatch({ type: REGISTER, payload: [] });

      const response = await API.post("/register", data);

      if (response.status) {
        dispatch({ type: REGISTER_SUCCESS, payload: response.data });
        return true;
      } else {
        dispatch({ type: REGISTER_FAILURE, payload: response.data.message });
        return false;
      }
    } catch (error: any) {
      dispatch({
        type: REGISTER_FAILURE,
        payload: error?.response?.data?.message,
      });
      return false;
    }
  };

export const loginUser =
  (email: string, password: string) =>
    async (dispatch: Dispatch<AuthActionTypes>) => {
      try {
        const response = await API.post("/login", { email, password });

        if (response.status) {
          localStorage.setItem("token", response.data.token);
          // localStorage.setItem("isRestrictedCustomer", response.data.user?.isRestrictedCustomer);
          dispatch({ type: LOGIN_SUCCESS, payload: response.data });
        } else {
          dispatch({ type: LOGIN_FAILURE, payload: response.data.message });
        }
      } catch (error: any) {
        dispatch({ type: LOGIN_FAILURE, payload: error.response?.data?.message });
      }
    };

export const getGoogleCallBack =
  (token: string) => async (dispatch: Dispatch<AuthActionTypes>) => {
    try {
      const response = await API.post("/auth/google/callback", { token });

      if (response?.data?.token) {
        localStorage.setItem("token", response?.data?.token);
        // localStorage.setItem("isRestrictedCustomer", response.data.user?.isRestrictedCustomer);
        dispatch({ type: LOGIN_SUCCESS, payload: response.data });
        // navigate(routes.userBookings);
      }
    } catch (error: any) {
      dispatch({ type: LOGIN_FAILURE, payload: error?.message });
    }
  };

export const getAddressFromCoords =
  () => async (dispatch: Dispatch<AuthActionTypes>) => {
    try {
      if (!navigator.geolocation) {
        throw new Error("Geolocation is not supported by this browser.");
      }

      dispatch({ type: GET_CURRENT_LOCATION, payload: "" });

      const position: GeolocationPosition = await new Promise(
        (resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        }
      );

      const { latitude, longitude } = position.coords;

      const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;

      const response = await fetch(url);
      const data = await response.json();

      if (data?.display_name) {
        dispatch({ type: GET_CURRENT_LOCATION, payload: data.display_name });
      } else {
        throw new Error("Unable to retrieve address.");
      }
    } catch (error: any) {
      console.error("Error fetching location:", error.message);
      dispatch({ type: GET_CURRENT_LOCATION, payload: "Location not found" });
    }
  };

export const logout = () => async (dispatch: Dispatch<AuthActionTypes>) => {
  try {
    const token = localStorage.getItem("token");
    const response = await API.post(
      "/logout",
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    localStorage.removeItem("token");
    // localStorage.removeItem("isRestrictedCustomer");

    dispatch({ type: LOGOUT, payload: response.data });
  } catch (error: any) {
    console.log(error.response.data);
  }
};

export const passwordReset =
  (data: any) => async (dispatch: Dispatch<AuthActionTypes>) => {
    try {
      dispatch({ type: RESET_PASSWORD, payload: [] });

      const response = await API.post("/forgot-password", data);
      if (response.status) {
        dispatch({ type: RESET_PASSWORD_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: RESET_PASSWORD_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: RESET_PASSWORD_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const passwordChange =
  (data: any) => async (dispatch: Dispatch<AuthActionTypes>) => {
    try {
      dispatch({ type: CHANGE_PASSWORD, payload: [] });

      const response = await API.post("/password/change", data);
      if (response.status) {
        dispatch({ type: CHANGE_PASSWORD_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: CHANGE_PASSWORD_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: CHANGE_PASSWORD_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };



export const getSettings =
  () => async (dispatch: Dispatch<AuthActionTypes>) => {
    try {
      dispatch({ type: SETTINGS, payload: [] });

      const response = await API.get("/public-settings", {});

      if (response.status) {
        dispatch({ type: SETTINGS_SUCCESS, payload: response.data });
      } else {
        dispatch({ type: SETTINGS_FAILURE, payload: response.data.message });
      }
    } catch (error: any) {
      dispatch({
        type: SETTINGS_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const getProfile = () => async (dispatch: Dispatch<AuthActionTypes>) => {
  try {
    dispatch({ type: USER_PROFILE, payload: [] });

    const response = await API.get("/user_profile", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    if (response.status) {
      dispatch({ type: USER_PROFILE_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: USER_PROFILE_FAILURE, payload: response.data.message });
    }
  } catch (error: any) {
    const status = error?.response?.status;
    if (status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
      return;
    }
    dispatch({
      type: USER_PROFILE_FAILURE,
      payload: error?.response?.data?.message,
    });
  }
};

export const updateProfile =
  (data: any) => async (dispatch: Dispatch<AuthActionTypes>) => {
    try {
      dispatch({ type: USER_PROFILE, payload: [] });

      const response = await API.put("/update_profile", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({ type: USER_PROFILE_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: USER_PROFILE_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: USER_PROFILE_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const updatePassword =
  (data: any) => async (dispatch: Dispatch<AuthActionTypes>) => {
    try {
      dispatch({ type: CHANGE_PASSWORD, payload: [] });

      const response = await API.put("/update_password", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.status) {
        dispatch({ type: CHANGE_PASSWORD_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: CHANGE_PASSWORD_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: CHANGE_PASSWORD_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const validatePassword =
  (data: any) => async (dispatch: Dispatch<AuthActionTypes>) => {
    try {
      dispatch({ type: PASSWORD_AUTHENTICATE, payload: [] });

      const response = await API.post("/verify-password", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({
          type: PASSWORD_AUTHENTICATE_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: PASSWORD_AUTHENTICATE_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: PASSWORD_AUTHENTICATE_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

  
export const verifyOtp =(data: any) =>
  async (dispatch: Dispatch<AuthActionTypes>) => {
    try {
      dispatch({ type: VERIFY_OTP, payload: [] });

      const response = await API.post("/forgotPasswordOtpVerification", data);
      if (response.status) {
        dispatch({ type: VERIFY_OTP_SUCCESS, payload: response.data });

      } else {
        dispatch({ type: VERIFY_OTP_FAILURE, payload: response.data.message });

      }
    } catch (error: any) {
      dispatch({
        type: VERIFY_OTP_FAILURE,
        payload: error?.response?.data?.message || "Invalid OTP",
      });

    }
  };

export const resetPasswordAuthenticate =
  () => (dispatch: Dispatch<AuthActionTypes>) => {
    dispatch({ type: RESET_PASSWORD_AUTHENTICATE });
  };

export const resetAuth = () => (dispatch: Dispatch<AuthActionTypes>) => {
  dispatch({ type: RESET_AUTH_STATE });
};


